import _classCallCheck from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Vector } from "./Vector";
export var Vector3d = /*#__PURE__*/function (_Vector) {
  _inherits(Vector3d, _Vector);

  var _super = _createSuper(Vector3d);

  function Vector3d(xOrCoords, y, z) {
    var _this;

    _classCallCheck(this, Vector3d);

    _this = _super.call(this, xOrCoords, y);

    if (typeof xOrCoords !== "number" && xOrCoords) {
      _this.z = xOrCoords.z;
    } else if (z !== undefined) {
      _this.z = z;
    } else {
      throw new Error("tsParticles - Vector not initialized correctly");
    }

    return _this;
  }

  _createClass(Vector3d, [{
    key: "add",
    value: function add(v) {
      return v instanceof Vector3d ? Vector3d.create(this.x + v.x, this.y + v.y, this.z + v.z) : _get(_getPrototypeOf(Vector3d.prototype), "add", this).call(this, v);
    }
  }, {
    key: "addTo",
    value: function addTo(v) {
      _get(_getPrototypeOf(Vector3d.prototype), "addTo", this).call(this, v);

      if (v instanceof Vector3d) {
        this.z += v.z;
      }
    }
  }, {
    key: "copy",
    value: function copy() {
      return Vector3d.clone(this);
    }
  }, {
    key: "div",
    value: function div(n) {
      return Vector3d.create(this.x / n, this.y / n, this.z / n);
    }
  }, {
    key: "divTo",
    value: function divTo(n) {
      _get(_getPrototypeOf(Vector3d.prototype), "divTo", this).call(this, n);

      this.z /= n;
    }
  }, {
    key: "mult",
    value: function mult(n) {
      return Vector3d.create(this.x * n, this.y * n, this.z * n);
    }
  }, {
    key: "multTo",
    value: function multTo(n) {
      _get(_getPrototypeOf(Vector3d.prototype), "multTo", this).call(this, n);

      this.z *= n;
    }
  }, {
    key: "setTo",
    value: function setTo(v) {
      _get(_getPrototypeOf(Vector3d.prototype), "setTo", this).call(this, v);

      var v3d = v;

      if (v3d.z !== undefined) {
        this.z = v3d.z;
      }
    }
  }, {
    key: "sub",
    value: function sub(v) {
      return v instanceof Vector3d ? Vector3d.create(this.x - v.x, this.y - v.y, this.z - v.z) : _get(_getPrototypeOf(Vector3d.prototype), "sub", this).call(this, v);
    }
  }, {
    key: "subFrom",
    value: function subFrom(v) {
      _get(_getPrototypeOf(Vector3d.prototype), "subFrom", this).call(this, v);

      if (v instanceof Vector3d) {
        this.z -= v.z;
      }
    }
  }], [{
    key: "clone",
    value: function clone(source) {
      return Vector3d.create(source.x, source.y, source.z);
    }
  }, {
    key: "create",
    value: function create(x, y, z) {
      return new Vector3d(x, y, z);
    }
  }, {
    key: "origin",
    get: function get() {
      return Vector3d.create(0, 0, 0);
    }
  }]);

  return Vector3d;
}(Vector);